var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"hello"},[_c('div',{staticClass:"container margin_60_35"},[_c('div',{staticClass:"row"},[_c('profileNav'),_c('MyAccount')],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }